<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M14 10.25v1.5c0 0.688-0.563 1.25-1.25 1.25h-11.5c-0.688 0-1.25-0.563-1.25-1.25v-1.5c0-0.688 0.563-1.25 1.25-1.25h11.5c0.688 0 1.25 0.563 1.25 1.25z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-window-minimize.html